import { AttachmentStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<AttachmentStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storage'],
      text: ['condition', 'prompt', 'promptMale', 'promptFemale']
    })
  )
}
